module.exports = __webpack_public_path__ + "img/Left_Panel_Image.e5c4ba08.svg";